import React, { useState, useEffect } from "react";
import {
  Box,
  Heading,
  useToast,
  Button,
  HStack,
  Skeleton,
} from "@chakra-ui/react";
import { useNavigate, useParams } from "react-router-dom";
import { BsArrowLeft } from "react-icons/bs";
import RequestForm from "../components/RequestForm";
import procurementApi from "../services/procurementApi";

const RequestEdit = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const toast = useToast();
  const [loading, setLoading] = useState(false);
  const [fetchLoading, setFetchLoading] = useState(true);
  const [requestData, setRequestData] = useState(null);

  useEffect(() => {
    fetchRequest();
  }, [id]);

  const fetchRequest = async () => {
    try {
      setFetchLoading(true);
      const response = await procurementApi.getRequestById(id);
      const request = response?.data || response;
      if (!request) {
        throw new Error("Request not found");
      }
      setRequestData(request);
    } catch (error) {
      toast({
        title: "Error fetching request",
        description: error.response?.data?.message || error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
      navigate("/procurement/requests");
    } finally {
      setFetchLoading(false);
    }
  };

  const handleSubmit = async (formData) => {
    try {
      setLoading(true);
      await procurementApi.updateRequest(id, {
        ...formData,
        requestUrlBase: window.location.origin,
      });
      toast({
        title: "Request updated successfully",
        status: "success",
        duration: 3000,
        isClosable: true,
      });
      navigate("/procurement/requests");
    } catch (error) {
      toast({
        title: "Error updating request",
        description: error.response?.data?.message || error.message,
        status: "error",
        duration: 3000,
        isClosable: true,
      });
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    navigate("/procurement/requests");
  };

  if (fetchLoading) {
    return (
      <Box p={6}>
        <Skeleton height="40px" mb={4} />
        <Skeleton height="600px" />
      </Box>
    );
  }

  return (
    <Box p={6}>
      <HStack mb={6}>
        <Button
          leftIcon={<BsArrowLeft />}
          variant="ghost"
          onClick={handleCancel}
        >
          Back
        </Button>
        <Heading size="lg">Edit Procurement Request</Heading>
      </HStack>
      <Box bg="white" p={6} borderRadius="lg" borderWidth="1px">
        <RequestForm
          initialData={requestData}
          onSubmit={handleSubmit}
          onCancel={handleCancel}
          isLoading={loading}
        />
      </Box>
    </Box>
  );
};

export default RequestEdit;
